'use strict';

var _ = require('lodash');
var DataExtractPanelController = function DataExtractPanelController($scope, constants, dataExtractPanelService) {
  var defaultView = constants.VIEW.SCHEDULED;
  $scope.selectedView = defaultView;
  $scope.views = [{
    label: 'Scheduled',
    value: constants.VIEW.SCHEDULED
  }, {
    label: 'Completed',
    value: constants.VIEW.COMPLETED
  }];
  $scope.showScheduledPanel = true;
  $scope.showCompletedPanel = false;
  $scope.showAddPanel = false;
  function isValidPanel(panel) {
    return _.values(constants.VIEW).indexOf(panel) !== -1;
  }
  function adjustViewVisibility(panel) {
    if (!isValidPanel(panel)) {
      panel = defaultView;
    }
    $scope.showScheduledPanel = panel === constants.VIEW.SCHEDULED;
    $scope.showCompletedPanel = panel === constants.VIEW.COMPLETED;
    $scope.showAddPanel = panel === constants.VIEW.NEW_EXTRACT;
  }
  function deleteSelectedScheduled(rowsToRemove) {
    dataExtractPanelService.deleteScheduled(rowsToRemove).then(function () {
      $scope.$broadcast('grid:dataChanged');
    });
  }
  function deleteSelectedCompleted(rowsToRemove) {
    var extractsToRemove = _.cloneDeep(rowsToRemove);
    _.forEach(extractsToRemove, function (extract) {
      extract.lastRun = extract.lastRun.toISOString();
    });
    dataExtractPanelService.deleteCompleted(extractsToRemove).then(function () {
      $scope.$broadcast('grid:dataChanged');
    });
  }
  $scope.$watch('selectedView', function () {
    adjustViewVisibility($scope.selectedView);
  });
  $scope.$on('data-extract:activatePanel', function (event, panel) {
    $scope.selectedView = panel;
    adjustViewVisibility(panel);
  });
  $scope.$on('data-extract:deleteSelectedScheduled', function (event, selected) {
    deleteSelectedScheduled(selected);
  });
  $scope.$on('data-extract:deleteSelectedCompleted', function (event, selected) {
    deleteSelectedCompleted(selected);
  });
  $scope.$on('data-extract:newExtract', function (event, registeredExtractNames) {
    $scope.editedSchedule = '';
    $scope.registeredExtractNames = registeredExtractNames;
    adjustViewVisibility(constants.VIEW.NEW_EXTRACT);
  });
  $scope.$on('data-extract:editExtract', function (event, selected) {
    $scope.editedSchedule = selected;
    adjustViewVisibility(constants.VIEW.NEW_EXTRACT);
  });
  $scope.$on('data-extract:runExtract', function (event, selected) {
    var config = selected.exportConfig;
    dataExtractPanelService.runScheduledExtract(config);
  });
};
DataExtractPanelController.$inject = ['$scope', 'DataExtractConstants', 'DataExtractPanelService'];
module.exports = DataExtractPanelController;